import { useState } from "react";
import { MessageSquare, Send, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

export default function ModuleComments({ moduleKey, item, onRefresh }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const comments = item?.comments || [];
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post(`/mod/${moduleKey}/items/${item.id}/comment`, { text });
      setText("");
      onRefresh && onRefresh();
    } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 rounded-lg border border-navy/10 p-4" data-testid="module-comments">
      <div className="overline text-navy/40 mb-3 flex items-center gap-1.5"><MessageSquare className="w-3.5 h-3.5" /> Comentarios · {comments.length}</div>
      <div className="space-y-3 mb-3 max-h-64 overflow-y-auto">
        {comments.length === 0 ? <p className="text-sm text-navy/35">Sé el primero en comentar.</p> :
          comments.map((c, i) => (
            <div key={i} className="text-sm" data-testid={`comment-${i}`}>
              <span className="font-medium text-navy/75">{c.name}</span>
              <p className="text-navy/60 whitespace-pre-wrap">{c.text}</p>
            </div>
          ))}
      </div>
      <div className="flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
          placeholder="Escribe un comentario…" data-testid="comment-input" className="field flex-1" />
        <button onClick={send} disabled={busy} data-testid="comment-send" className="btn btn-primary shrink-0">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );
}
